// extracted by mini-css-extract-plugin
export default {"memberPanel":"MemberLimit_memberPanel__0uEk1","title":"MemberLimit_title__764tI","numberCtrl":"MemberLimit_numberCtrl__dlBKv"};